import fetchWrapper from "../../../utils/fetchWrapper";

const vanityUrlService = () => {
  const search = async(pattern) => {
    const url = `api/customUrls/${pattern}`;
    const data = await fetchWrapper({url});
    return data;
  }
  return {
    search
  }
};

export default vanityUrlService;